
import Shop from "examples/Icons/Shop";
import Basket from "examples/Icons/Basket";
import CustomerSupport from "examples/Icons/CustomerSupport";
import SpaceShip from "examples/Icons/SpaceShip";
import FinancialDocument from "examples/Icons/FinancialDocument";
import { useTranslation } from "react-i18next";
import Office from "examples/Icons/Office";

const useNavRoutes = () => {
  const { t } = useTranslation();
  const userData = JSON.parse(localStorage.getItem("user"));
  const role = userData?.business_role_id || null;
  const dashboard_access = role === "warehouse_owner" || role === "admin";

  const navRoutes = [
    {
      type: "collapse",
      name: t("Entreprise"),
      key: "entreprise",
      icon: <Office size="12px" />,
      collapse: [
        {
          name: t("Informations sur l'entreprise"),
          key: "informations-entreprise",
          route: "/entreprise/informations-entreprise",
          protected: true,
        },
        {
          name: t("Nouveau entrepôt"),
          key: "nouveau-entrepot",
          route: "/entreprise/nouveau-entrepot",
          protected: true,
        },
        {
          name: t("Informations sur les entrepôts"),
          key: "informations-entrepots",
          route: "/entreprise/informations-entrepots",
          protected: true,
        },
        {
          name: t("Rapports générales"),
          key: "rapports-generales",
          route: "/rapports/rapports-generales",
          protected: true,
        },
        {
          name: t("Statistiques générales"),
          key: "statistiques-generales",
          route: "/statistiques/statistiques-generales",
          protected: true,
        },
      ].filter(Boolean),
    },
    {
      type: "collapse",
      name: t("Gestion des commandes"),
      key: "gestion-des-commandes",
      icon: <Basket size="12px" />,
      collapse: [
        {
          name: t("Ajouter commande"),
          key: "ajouter-commande",
          route: "/gestion-des-commandes/ajouter-commande",
          protected: true,
        },
        {
          name: t("Panier d'achat en cours"),
          key: "paniers-en-cours",
          route: "/paniers-ouverts/paniers-en-cours",
          protected: true,
        },
        {
          name: t("Commandes encours"),
          key: "commandes-encours",
          route: "/gestion-des-commandes/commandes-encours",
          protected: true,
        },
        {
          name: t("Commandes confirmées"),
          key: "commandes-confirmees",
          route: "/gestion-des-commandes/commandes-confirmees",
          protected: true,
        },
        {
          name: t("Commandes expediées"),
          key: "commandes-expediees",
          route: "/gestion-des-commandes/commandes-expediees",
          protected: true,
        },
        {
          name: t("Commandes livrées"),
          key: "commandes-livrees",
          route: "/gestion-des-commandes/commandes-livrees",
          protected: true,
        },
        {
          name: t("Commandes annulées"),
          key: "commandes-annulees",
          route: "/gestion-des-commandes/commandes-annulees",
          protected: true,
        },
      ].filter(Boolean),
    },

    {
      type: "collapse",
      name: t("Gestion des ventes"),
      key: "gestion-des-ventes",
      icon: <CustomerSupport size="12px" />,
      collapse: [
        {
          name: t("Ajouter client"),
          key: "nouveau-client",
          route: "/gestion-des-ventes/nouveau-client",
          protected: true,
        },
        {
          name: t("Liste des clients"),
          key: "liste-des-clients",
          route: "/gestion-des-ventes/liste-des-clients",
          protected: true,
        },
        dashboard_access && {
          name: t("ajouter manager"),
          key: "nouveau-manager",
          route: "/gestion-des-ventes/nouveau-manager",
          protected: true,
        },
        {
          name: t("liste des managers"),
          key: "liste-des-managers",
          route: "/gestion-des-ventes/liste-des-managers",
          protected: true,
        },
        {
          name: t("Balance clients"),
          key: "balance-clients",
          route: "/gestion-des-ventes/balance-clients",
          protected: true,
        },
        {
          name: t("Compte client"),
          key: "compte-client",
          route: "/gestion-des-ventes/compte-client",
          protected: true,
        },
        {
          name: t("Etablir une facture"),
          key: "etablir-une-facture",
          route: "/gestion-des-ventes/etablir-une-facture",
          protected: true,
        },
        {
          name: t("Etat de facture"),
          key: "etat-de-facture",
          route: "/gestion-des-ventes/etat-de-facture",
          protected: true,
        },
        {
          name: t("Etat de bon de livraison"),
          key: "etat-de-bon-de-livraison",
          route: "/gestion-des-ventes/etat-de-bon-de-livraison",
          protected: true,
        },
      ].filter(Boolean),
    },

    {
      type: "collapse",
      name: t("Gestion de stock"),
      key: "gestion-de-stock",
      icon: <Shop size="12px" />,
      collapse: [
        {
          name: t("Ajouter articles"),
          key: "ajouter-articles",
          route: "/gestion-de-stock/ajouter-articles",
          protected: true,
        },
        {
          name: t("Liste des articles"),
          key: "liste-des-articles",
          route: "/gestion-de-stock/liste-des-articles",
          protected: true,
        },
        {
          name: t("Nouveau stock"),
          key: "nouveau-stock",
          route: "/gestion-de-stock/nouveau-stock",
          protected: true,
        },
        {
          name: t("Augmenter le stock"),
          key: "augmenter-le-stock",
          route: "/gestion-de-stock/augmenter-le-stock",
          protected: true,
        },
        {
          name: t("Liste des fournisseurs"),
          key: "listes-des-fournisseurs",
          route: "/gestion-de-stock/listes-des-fournisseurs",
          protected: true,
        },
        {
          name: t("Situation de stock"),
          key: "situation-de-stock",
          route: "/gestion-de-stock/situation-de-stock",
          protected: true,
        },
        {
          name: t("Mes demandes de stock"),
          key: "mes-demandes-de-stock",
          route: "/gestion-de-stock/mes-demandes-de-stock",
          protected: true,
        },
      ].filter(Boolean),
    },
    {
      type: "collapse",
      name: t("Gestion des promotions"),
      key: "gestion-des-promotions",
      icon: <SpaceShip size="12px" />,
      collapse: [
        {
          name: t("Nouvelle promotion"),
          key: "nouvelle-promotion",
          route: "/gestion-des-promotions/nouvelle-promotion",
          protected: true,
        },
        {
          name: t("Liste des promotions"),
          key: "liste-des-promotions",
          route: "/gestion-des-promotions/liste-des-promotions",
          protected: true,
        },
        {
          name: t("Nouvelle notification"),
          key: "nouvelle-notification",
          route: "/gestion-des-promotions/nouvelle-notification",
          protected: true,
        },
        {
          name: t("Liste des notfications"),
          key: "liste-des-notifications",
          route: "/gestion-des-promotions/liste-des-notifications",
          protected: true,
        },
      ],
    },
    {
      type: "collapse",
      name: t("Gestion financière"),
      key: "gestion-financiere",
      icon: <FinancialDocument size="12px" />,
      collapse: [
        dashboard_access && {
          name: t("Nouvelle caisse"),
          key: "nouvelle-caisse",
          route: "/gestion-financiere/nouvelle-caisse",
          protected: true,
        },
        {
          name: t("Liste des caisses"),
          key: "liste-des-caisses",
          route: "/gestion-financiere/liste-des-caisses",
          protected: true,
        },
        dashboard_access && {
          name: t("Nouvelle banque"),
          key: "nouvelle-banque",
          route: "/gestion-financiere/nouvelle-banque",
          protected: true,
        },
        {
          name: t("Liste des banques"),
          key: "liste-des-banques",
          route: "/gestion-financiere/liste-des-banques",
          protected: true,
        },
        {
          name: t("Certificat retenue a la ressources"),
          key: "generation-de-certificat-retenue-ressource",
          route:
            "/gestion-financiere/generation-de-certificat-retenue-ressource",
          protected: true,
        },
        {
          name: t("Dépenses"),
          key: "expenses",
          route: "/gestion-financiere/expenses",
          protected: true,
        },
      ].filter(Boolean),
    },
  ];

  return navRoutes;
};

export default useNavRoutes;
